/**
 * Side-menu "EGMs" category visibility (Reports-style parent + children).
 * Children keep their own Cognito gates.
 */

import { canAccessManufacturersManagement } from './manufacturersManagementAccess';
import { canAccessGameNamesManagement } from 'pages/GameNamesManagement/gameNamesManagementAccess';

export const CLOAK_EGMS_GROUP = 'slotcheck-enterprise-cloakTheEgms';

export function canAccessCloakEgms(groups: string[] = []): boolean {
  return Array.isArray(groups) && groups.includes(CLOAK_EGMS_GROUP);
}

/** Parent "EGMs" category shows when the user can see at least one child. */
export function shouldShowEgmsMenuCategory(groups: string[] = []): boolean {
  return (
    canAccessCloakEgms(groups) ||
    canAccessManufacturersManagement(groups) ||
    canAccessGameNamesManagement(groups)
  );
}

export function shouldShowCloakEgmsMenuItem(groups: string[] = []): boolean {
  return canAccessCloakEgms(groups);
}

export function shouldShowManufacturersManagementMenuItem(groups: string[] = []): boolean {
  return canAccessManufacturersManagement(groups);
}

export function shouldShowGameNamesManagementMenuItem(groups: string[] = []): boolean {
  return canAccessGameNamesManagement(groups);
}
